import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BreakdownReasonService } from '../../../../../services/table-management/breakdownReason.service';
import { Rest } from '../../../../../../../rest/rest_client';
import { NotificationsService } from '../../../../../../../services/notifications-service/notifications.service';
import { I18nService } from '../../../../../../../services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../../core/services/authentication/authentication.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';

@Component({
  selector: 'app-breakdown-reason-form',
  templateUrl: './breakdown-reason-form.component.html',
  styleUrls: ['./breakdown-reason-form.component.css'],
  providers: [BreakdownReasonService],
  standalone: false,
})
export class BreakdownReasonFormComponent extends EntityFormComponent<Rest.InvBreakdownReason> implements OnInit {
  active: boolean;
  title: string;
  formManipulation: boolean;
  disableGranted: boolean;
  constructor(
    private breakdownReasonService: BreakdownReasonService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
  ) {
    super(breakdownReasonService, notificationsService, i18n, authenticationService);
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof AccessoryFormComponent
   */
  beforeShow() {
    this.active = !this.entity.disabled;

    if (this.isNew) {
      this.title = this.translateService.instant('tableManagement.breakdown.breakdownReason.createBreakdownReason');
    } else {
      this.title = this.translateService.instant('tableManagement.breakdown.breakdownReason.updateBreakdownReason');
    }

    this.setPermissions();
  }

  setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_BREAKDOWN_REASON_CREATE', 'INV_BREAKDOWN_REASON_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);
    this.disableGranted = this.authenticationService.isRoleGranted("INV_BREAKDOWN_REASON_DISABLE", user);

  }
}